<template>
  <div>
    <!-- scroll up to "about" section -->
    <ScrollUpButton />
    <footer id="footer" class="footer">
      <div class="footer__content">
        <!-- copyrights -->
        <div class="footer__content-copyrights">©2020 Created by Adele Angel</div>

        <!-- source code on GitHub -->
        <div class="footer__content-source">
          <a href="https://github.com/adele-angel/adele-angel.github.io">
            <font-awesome-icon :icon="['fas', 'code']" class="footer__icons" />&nbsp;&nbsp;view source code
          </a>
        </div>

        <!-- social icons -->
        <div class="footer__content-icons">
          <a href="https://github.com/adele-angel">
            <font-awesome-icon :icon="['fab', 'github']" class="footer__content-icons__icon" />
          </a>
          <a href="https://www.linkedin.com/in/adele-angel-678bb7165">
            <font-awesome-icon :icon="['fab', 'linkedin']" class="footer__content-icons__icon" />
          </a>
          <router-link to="/">
            <font-awesome-icon
              :icon="['fab', 'xing']"
              label="Xing Profile"
              class="footer__content-icons__icon"
            />
          </router-link>
          <router-link to="/">
            <font-awesome-icon :icon="['fab', 'codepen']" class="footer__content-icons__icon" />
          </router-link>
        </div>

        <!-- themes change: Dark/Light -->
        <div class="footer__content-theme">
          <font-awesome-icon
            @click="onChangeTheme"
            :icon="['fas', theme.icon]"
            class="footer__content-theme__icon"
          />
        </div>
      </div>
    </footer>
  </div>
</template>

<script>
import ScrollUpButton from "@/components/home/ScrollUpButton";

export default {
  name: "Footer",
  components: {
    ScrollUpButton
  },
  data() {
    return {
      theme: {
        mode: "dark",
        icon: "moon"
      }
    };
  },
  methods: {
    onChangeTheme() {
      if (this.theme.mode === "dark") {
        this.theme.mode = "light";
        this.theme.icon = "sun";
      } else {
        this.theme.mode = "dark";
        this.theme.icon = "moon";
      }
    }
  }
};
</script>
